import { render } from "./viewProductsView.vue?vue&type=template&id=32ef4140"
import script from "./viewProductsView.vue?vue&type=script&lang=js"
export * from "./viewProductsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__